export default __webpack_public_path__ + "static/media/VID-20200222-WA0009.5af45b08.mp4";